import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { parametrizeFilter } from '../FilterContent';

import ActionButton from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import DateTimePicker from '../builder/DateTimePicker';
import FloatingLayer from '../builder/FloatingLayer';
import Input from '../builder/Input';
import NavigationTabs from '../builder/NavigationTabs';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';
import FieldErrorMessage from '../builder/FieldErrorMessage.js';

const FilterModalInLayer = ({ filters, dispatch, toggle, ...props }) =>{
	return (
		<FloatingLayer backButton={() => toggle(false)}>
			<div>
				<SectionTitle _class={{icon:'knk-filter'}}>Filter entries</SectionTitle>

				<SectionSubtitle>Follow the steps to filter by the criteria you need</SectionSubtitle>

				<FilterModal
					{...props}
					filters={filters}
					dispatch={dispatch}
					toggle={toggle}
					in_layer={true}
				/>
			</div>
		</FloatingLayer>
	)
}

const FilterType = ({ tier, currentFilter, addFilter, setCurrentFilter, intl }) => {
	const i18n = (m, c) => i18nIntl(m, intl, c);
	let field_label = (tier.label != undefined) ? tier.label : "Field";

	return (
		<div class="gui_pos_rel">
			{(tier.extra != undefined && tier.extra != "") && (
				<div class="extra_content">{tier.extra}</div>
			)}

			{(tier.type == 'no_actions') && (
				<div class="empty_section">
					<p><strong>{i18n("This filter has no additional options")}</strong></p>
				</div>
			)}

			{(tier.type == 'input') && (
				<Input
					name="value"
					value={currentFilter.value}
					onEnter={addFilter}
					change={(k, v) => setCurrentFilter({...currentFilter, value:v})}
					_class={{first:true}}
					{...tier.field_options}
				>{field_label}</Input>
			)}

			{(tier.type == 'date') && (
				<DateTimePicker
					value={currentFilter.value}
					name="date"
					change={(k, v) => setCurrentFilter({
						...currentFilter,
						type:'date',
						value:v.format('YYYY-MM-DD HH:mm:ss'),
					})}
					_class={{first:true}}
					{...tier.field_options}
					time_interval={30}
				>{field_label}</DateTimePicker>
			)}

			{(tier.type == 'between') && (
				<>
				<DateTimePicker
					value={currentFilter.start}
					name="start"
					change={(k, v) => setCurrentFilter({
						...currentFilter,
						type:'date',
						start:v.format('YYYY-MM-DD HH:mm:ss'),
					})}
					_class={{first:true}}
					{...tier.field_options}
					time_interval={30}
				>Start Date</DateTimePicker>
				<DateTimePicker
					value={currentFilter.end}
					name="end"
					change={(k, v) => setCurrentFilter({
						...currentFilter,
						type:'date',
						end:v.format('YYYY-MM-DD HH:mm:ss'),
					})}
					_class={{first:false}}
					{...tier.field_options}
					time_interval={30}
				>End Date</DateTimePicker>
				</>
			)}

			{(tier.type == 'button') && (
				<ActionButton
					onClick={addFilter}
				>Confirm</ActionButton>
			)}
		</div>
	)
}

export const FilterModal = ({filters, dispatch, ...props}) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ currentFilter, setCurrentFilter ] = useState({});
	const [ findFilter, setFindFilter ] = useState('');
	const [ group, setGroup ] = useState('user');
	const [ error, setError ] = useState(null);

	const setFilter = (f) => {
		if (f.filter.type == 'matchAll') {
			f.value = f.filter.getOptions(f.filter,0).options;
			f.logic = "AND";
			dispatch({
				type:'ADDFILTER',
				filter:f,
			});
			setCurrentFilter({});
			return;
		}
		setCurrentFilter(f);
	}

	const addFilter = (value, params, closeLayer = true) => {
		
		if(currentFilter.filter != undefined) {
			if(currentFilter.filter.skip_reapeated_key){
				const all_filters = props.stateFilters;
				const already_filter = all_filters.find((f) => f.condition == currentFilter.filter.key) != null;
				if(already_filter){
					if(props.setError != undefined)props.setError("This condition already exists and can only be used once. Please try again by removing the existing one.")
					setCurrentFilter({});
					return;
				}
			}
			setError(null)
			if(currentFilter.filter.getValue != undefined) {
				params = currentFilter.filter.getValue(currentFilter);
			}

			let filter = parametrizeFilter(currentFilter, params);

			if(Array.isArray(filter.value)) filter.value = filter.value.map((v) => v.k);
			if(filter.key == 'questions.answer'){//permetre filtrar per més d'una resposta
				filter['key'] = `questions${(filter?.options?.[1]?.k)}.answer`
			}
			dispatch({
				type:'ADDFILTER',
				filter:(value != undefined) ? {...filter, value} : filter,
			});
		}

		if(closeLayer) {
			if(props.toggle != undefined)props.toggle(false);
			dispatch({
				type:'APPLYFILTERS',
			});
		}

		setCurrentFilter({});
	};

	const applyOperator = (operator) => {
		if(operator == undefined) operator = 'OR';
		currentFilter.logic = operator;
		setCurrentFilter({...currentFilter});
	};

	const goToFilterArea = (group_name) => {
		setGroup(group_name);
		setCurrentFilter({});
	};

	const total_steps_passed = (currentFilter != undefined && currentFilter.options != undefined) ? currentFilter.options.length : 0;
	const min_cols_to_display = 2;

	let pending_cols = [];
	if(total_steps_passed < min_cols_to_display + 1) {
		for(var i = total_steps_passed + 1; i < min_cols_to_display; i++) pending_cols.push(i);
	}

	const display_join_operator_picker = (currentFilter != undefined && currentFilter.filter != undefined && currentFilter.filter.allowMatchAll != undefined && Array.isArray(currentFilter.options) && currentFilter.options[currentFilter.options.length-1].length > 1) ? currentFilter.filter.allowMatchAll : false;
	const sections = (props.sections != undefined) ? props.sections.map((section) => {
		return {
			...section,
			onClick:() => goToFilterArea(section.key),
			selected:(group == section.key) ? true : false,
		}
	}) : [{
		label:i18n("Users"),
		onClick:() => goToFilterArea('user'),
		selected:(group == 'user') ? true : false,
	}, {
		label:i18n("Prizes"),
		onClick:() => goToFilterArea('prize'),
		selected:(group == 'prize') ? true : false,
		enabled:(props?.prizes ?? []).length > 0 ? true : false
	}, {
		label:i18n("Stages"),
		onClick:() => goToFilterArea('stage'),
		selected:(group == 'stage') ? true : false,
		enabled:(props?.stages ?? []).length > 0 ? true : false
	}];

	return (
		<>
			<div class="gui_filter_layer gui_pos_rel">
				{(sections.length > 1) && (
					<NavigationTabs
						sections={sections}
						display_type='tab'
						_class={{other:'not_in_top'}}
					/>
				)}

				<section class={`filter_boxes${(sections.length > 1) ? ' with_tabs' : ''}`}>
					<div>
						<div class="filter_column">
							{/*<SearchField _class={{first:true}} placeholder="Find filters" change={(k, v) => setFindFilter(v)} />*/}

							<div class="gui_buttoned_actions visible_overflowed_container">
								{filters.filter((f) => {
									if(findFilter != "") return RegExp(findFilter, 'i').test(f.name);

									if(f.disabled)return null;
									if(group) {
										return (f.group == group) ? true : false;
									} else {
										return (f.group == undefined) ? true : false;
									}
								}).map((filter, fl) => {
									let f = { key:filter.key, filter:filter, options:[{ k:null, v:null }] };

									if(f.getDefault != undefined) f.options = f.getDefault();
									let selected = filter.key == currentFilter.key;
									return (
										<span key={`filter_${fl}`} class={((selected) ? 'selected' : null)}>
											<ActionButton
												_fullclass="cutTextOnOverflow"
												onClick={() => setFilter(f)}
											>{filter.name}</ActionButton>
										</span>
									)
								})}
							</div>
						</div>
					</div>

					{total_steps_passed > 0 && currentFilter.options.map((option, option_index) => {
						const tier = currentFilter.filter.getOptions(currentFilter, option_index);
						if(!tier)return null;
						if(tier?.type != undefined && tier?.type != 'multiple') {
							return (
								<FilterType key={`col_${option_index}`} tier={tier} currentFilter={currentFilter} addFilter={addFilter} setCurrentFilter={setCurrentFilter} intl={props.intl} />
							)
						}
						return (
							<div key={`col_${option_index}`}>
								<div class="filter_column">
									<div class="gui_buttoned_actions visible_overflowed_container">
										{(tier?.options ?? []).map((filter_option, index) => {
											let selected = false;
											if(Array.isArray(option)) {
												if(option.find((opt) => opt.k == filter_option.k) != null) selected = true;
											} else {
												selected = (filter_option.k == option.k) ? true : false;
											}

											if(filter_option.v == undefined || filter_option.v == "") return null;

											const _autotranslate = currentFilter.key != 'custom_fields';
											return (
												<span key={`${option_index}_${index}`} class={((selected) ? 'selected' : null)}>
													<ActionButton
														autotranslate={_autotranslate}
														_fullclass="cutTextOnOverflow"
														onClick={() => setCurrentFilter((cf) => {
															let options = cf.options;
															if(tier.type && tier.type == 'multiple') {
																let v = (Array.isArray(options[option_index])) ? options[option_index] : [];

																let removed = false;
																v = v.filter((val) => {
																	if(val.k == filter_option.k) {
																		removed = true;
																		return false;
																	}

																	return true;
																});

																if(!removed) v = [...v, filter_option];

																options[option_index] = v;

																if(tier.key == 'value') cf.value = v;
																if (tier.fixed != undefined) cf.value = 1;

															} else {
																options[option_index] = { k:filter_option.k, v:filter_option.v };
																if(tier.key == 'operator') {
																	cf.operator = filter_option.k;
																	if (tier.forcetype != undefined) currentFilter.filter.type = tier.forcetype;
																}
																if(tier.key == 'value') cf.value = filter_option.k;
															}

															//Prepare next tier
															if(options[option_index + 1] == undefined) {
																const nextOptions = currentFilter.filter.getOptions(currentFilter, option_index + 1)
																options = (nextOptions == null) ? options : [...options, nextOptions];
															}
															return { ...cf, options:[...options] };
														})}
													>{filter_option.v}</ActionButton>
												</span>
											)
										})}
									</div>

									{(display_join_operator_picker && tier.key != 'operator') && (
										<div class="boolean_operator_selector">
											<ActionButton
												color={(currentFilter.logic == 'OR') ? 'blue' : 'white'}
												onClick={() => applyOperator('OR')}
											>Match at least one (default)</ActionButton>

											<ActionButton
												color={(currentFilter.logic == 'AND') ? 'blue' : 'white'}
												onClick={() => applyOperator('AND')}
											>Must match all options</ActionButton>
										</div>
									)}
								</div>
							</div>
						)}
					)}

					{pending_cols.map((col, c) => {
						return (
							<div key={`empty_col_${c}`}>
								<div class="empty_section">
									<p><strong>{i18n("Select an item from the left")}</strong></p>
									<p>{i18n("Additional options will show here")}</p>
								</div>
							</div>
						)
					})}
				</section>

				<div style={{paddingTop:'2em'}}>
					{(props.children != undefined) && (
						<span>{props.children}</span>
					)}
				</div>

				
			</div>

			{(props.in_layer) ? (
				(props.stateFilters.length > 0 || (currentFilter.filter != undefined && currentFilter.filter.noValue) || (currentFilter.value !== undefined && currentFilter.value !== "")) ? (
					<ButtonCollection in_floating={true}>
						<ActionButton
							onClick={() => addFilter()}
						>Apply filters</ActionButton>
						
						<ActionButton
							onClick={() => addFilter(undefined, undefined, false)}
						>Add filter</ActionButton>
					</ButtonCollection>
				) : (
					<ButtonCollection in_floating={true}>
						<ActionButton
							disabled={true}
						>Apply filter</ActionButton>

						<ActionButton
							disabled={true}
						>Add filter</ActionButton>
					</ButtonCollection>
				)		
			) : (
				<ButtonCollection>
					<ActionButton
						onClick={() => addFilter(undefined, undefined, false)}
					>Add filter</ActionButton>
				</ButtonCollection>
			)}
				
		</>
	);
}

export default injectIntl(FilterModalInLayer);